import { type MentionDescription } from '@atlaskit/mention';
import { SmartMentionResource } from '@atlassian/smart-mention-resource';

import { currentSiteData } from '@canvas/canvas-state/site-data';

import { addSelectedMention } from './mentions-state.ts';

class MentionProvider extends SmartMentionResource {
  recordMentionSelection(mention: MentionDescription) {
    addSelectedMention({
      id: mention.id,
      avatarUrl: mention.avatarUrl ?? '',
    });
  }
}

let mentionProvider: Promise<SmartMentionResource>;

export const getMentionProvider = (accountId?: string, cloudId?: string) => {
  if (mentionProvider) {
    return mentionProvider;
  }

  mentionProvider = Promise.resolve(
    new MentionProvider({
      productKey: 'confluence',
      shouldHighlightMention: (mention) => mention.id === accountId,
      siteId: cloudId ?? currentSiteData.siteId ?? '',
      includeTeams: true,
      includeUsers: true,
    }),
  );

  return mentionProvider;
};
